module.exports = __webpack_public_path__ + "media/flags/gm-46bec36c.svg";